import React from "react";
import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import SliderInput from '../inputs/SliderInput'
import LoaderButton from "../LoaderButton";
import { translate } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';


class SliderWidget extends React.Component {

    state = {
        showCurrentValue: false,
        style: {
            trackStyle: { backgroundColor: 'rgb(51, 98, 229)', height: 10 },
            railStyle: { height: 10 },
            handleStyle: { height: 18, width: 18, borderColor: 'rgb(54, 100, 302)' }
        }
    }


    changeValue = (key, value) => {
        this.setState({ currentValue: value })
        console.log(value)
        this.submit(value)
    }

    
    submit = (value) => {
        HttpServices.request("postActionTrigger", {dashboard:this.props.dashboard?._id, trigger: this.props.data.id,  value }, (fetchResult, fetchError, status) => {
            console.log(fetchResult)
            console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.submittedSuccesfully', description: '{{lang}}info.dataSubmittedSuccessfully' })

        })
    }


    render() {
        let data = this.props.data
        return (
            <div className="w-100 h-100  px-2 flexcc flex-column" style={{ minHeight: 120, height: '100%', maxHeight: '600px', overflow: 'auto' }} >

                <div className="w-100" style={{ position: 'relative' }}>

                    <SliderInput header={{ information: { steps: data.steps, min: data.min, max: data.max, type: 'slider', alwaysShowTooltip: true, trackStyle: this.state.style.trackStyle, railStyle: this.state.style.railStyle, handleStyle: this.state.style.handleStyle, } }} changeValue={this.changeValue} />
                    {this.state.showCurrentValue && (
                        <div style={{ position: 'absolute', top: 40, left: 0, width: '100%', opacity: 0.5 }}>
                            <SliderInput data={this.state.currentValue} header={{ information: { steps: data.steps, min: data.min, max: data.max, type: 'slider', tooltipPosition: 'bottom', hideNumber: true, disabled: true, alwaysShowTooltip: true, trackStyle: { height: 5 } } }} changeValue={this.changeValue} />
                        </div>
                    )}
                </div>
                {/* {data.action && data.action != '' && (
                    <LoaderButton
                        onClick={this.submit}
                        isLoading={this.state.isLoading}
                        text={translate("submit")}
                        type={"Oval"}
                        className="mt-4 mb-4"
                        buttonStyle={{ outline: 'none', backgroundColor: this.state.submitAllowed ? ' rgb(51, 98, 229)' : '#9ab', cursor: 'pointer', padding: '7px 40px', borderRadius: 4, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                        width={40}
                        height={40}
                        color={'#202020'}
                    />
                )} */}

            </div >
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SliderWidget);

